import React, { useState } from "react";
import { Container, Card, Row, Col, Form } from "react-bootstrap";
import * as yup from "yup";
import { Formik } from "formik";

import { auth, useUser } from "../firebase";
import LoadingButton from "../components/LoadingButton";
import FormTextbox from "../components/FormTextbox";
import HeaderBar from "../components/HeaderBar";


const DeleteUser = ({ location }) => {
  const { user, deleteUser } = useUser();
  const [error, setError] = useState("");
  const passwordRequired = user.providerData[0].providerId === 'password';
  const handleLogin = async (values, actions) => {
    try {
      await deleteUser(values.confirmEmail, values.password);
      actions.setSubmitting(false);
    } catch (error) {
      switch (error.code) {
        case "auth/wrong-password":
          actions.setFieldError("password", error.message);
          break;
        case "auth/weak-password":
          actions.setFieldError("password", error.message);
          break;
        default:
          setError(error.message);
      }
      actions.setSubmitting(false);
    }
  };
  const validationSchema = yup.object().shape({
    confirmEmail: yup
      .string()
      .required("Confirm Email is required")
      .matches(user.email, "Please type your email to confirm"),
    password: yup.string()
  });

  return (
    <>
      <HeaderBar className="text-danger" heading="Delete User" />
      <Container>
        <Row className="justify-content-center mt-4">
          <Col md="4">
            <Card className="p-4">
              <>
                {error && <div className="alert alert-danger">{error}</div>}
                <Formik
                  initialValues={{
                    confirmText: ""
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleLogin}
                >
                  {formik => (
                    <Form noValidate onSubmit={formik.handleSubmit}>
                      <FormTextbox
                        formik={formik}
                        controlId="confirmEmail"
                        label={`Please type "${user.email}" to confirm`}
                      />
                      {passwordRequired &&
                      <FormTextbox
                        formik={formik}
                        controlId="password"
                        label="Password"
                        password
                      />
                      }
                      <LoadingButton
                        isLoading={formik.isSubmitting}
                        variant="danger"
                        type="submit"
                        className="w-100"
                      >
                        Delete User
                      </LoadingButton>
                    </Form>
                  )}
                </Formik>
              </>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default DeleteUser;
